import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-dspl-percent',
    template: `
        <ng-container *ngIf="mode === 'normal'">
            <span dir="ltr">{{formattedPercent()}}</span>
        </ng-container>
        <ng-container *ngIf="mode === 'advance'">
            <div dir="ltr" class="data-rise" *ngIf="percent > 0">
                {{ formattedPercent() }}
                <svg class="icon icon-arrow-up">
                    <use xlink:href="#icon-arrow-up"></use>
                </svg>
            </div>
            <div class="data-fall" *ngIf="percent < 0">
                <span dir="ltr">{{ formattedPercent() }}</span>
                <svg class="icon icon-arrow-down">
                    <use xlink:href="#icon-arrow-down"></use>
                </svg>
            </div>
            <div dir="ltr" class="data-constant" *ngIf="percent == 0">
                {{ formattedPercent() }}
                <svg class="icon icon-Union-12">
                    <use xlink:href="#icon-Union-12"></use>
                </svg>
            </div>
        </ng-container>
    `,
})
export class ElDsplPercentComponent {
    @Input() mode: 'normal' | 'advance' = 'normal';
    @Input() percent: number;
    currentLang: string = localStorage.getItem('language') || 'en-US';
    public formattedPercent() {
        return `${Number(this.percent).toFixed(2)}%`;
    }
}
